export default __webpack_public_path__ + "static/media/hackgirl.e9980fba.jpg";